import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiHost } from '../../../../app/infrastructure/http/apiClient';
import type {
  PublicMentorProfile,
  PublicStudentProfile,
} from '../../application/types';

function apiBaseUrl(): string {
  const host = getApiHost();
  return host.endsWith('/') ? host : `${host}/`;
}

function unwrap<T>(response: unknown): T {
  if (response && typeof response === 'object' && 'data' in response) {
    const data = (response as { data?: T }).data;
    if (data && typeof data === 'object') return data;
  }
  return response as T;
}

export const publicProfileApi = createApi({
  reducerPath: 'publicProfileApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl(),
    credentials: 'include',
  }),
  endpoints: (build) => ({
    getPublicMentorBySlug: build.query<PublicMentorProfile, string>({
      query: (slug) => ({
        url: `public/mentors/${encodeURIComponent(slug)}`,
        method: 'GET',
      }),
      transformResponse: (response: unknown) =>
        unwrap<PublicMentorProfile>(response),
    }),
    getPublicStudentBySlug: build.query<PublicStudentProfile, string>({
      query: (slug) => ({
        url: `public/students/${encodeURIComponent(slug)}`,
        method: 'GET',
      }),
      transformResponse: (response: unknown) =>
        unwrap<PublicStudentProfile>(response),
    }),
  }),
});

export const {
  useGetPublicMentorBySlugQuery,
  useGetPublicStudentBySlugQuery,
} = publicProfileApi;
